export const root = '/'
export const controlsDemo = '/controlsDemo'
export const todoComponent = '/todoComponent'
export const formDemo = '/formDemo'
export const formDemoEdit = '/formDemoEdit'
export const createJob = '/createJob'
export const popperDemo = '/popperDemo'
export const adminDashboard = '/adminDashboard'
export const supervisorDashboard = '/supervisorDashboard'
export const login = '/login'
export const createTemplate = '/createTemplate'
export const editTemplate = '/editTemplate'
export const assignJob = '/assignJob'
export const editJob = '/editJob'
export const dataEntry = '/dataEntry'
export const userDashboard = '/userDashboard'
export const superUserDashboard = '/superUserDashboard'
export const customerReports = '/customerReports'
export const employeeReports = '/employeeReports'
export const qualityCheck = '/qualityCheck'
export const fileQualityCheck = '/fileQualityCheck'
export const viewAllFileQualityCheck = '/viewAllfileQualityCheck'
export const boxQualityCheck = '/boxQualityCheck'
export const boxFlowQualityCheck = '/boxFlowQualityCheck'
export const AllJobs = '/AllJobs'
export const AllOpenJobs = '/AllOpenJobs'
export const ClosedJobs = '/ClosedJobs'
export const myJobs = '/myJobs'
export const templateSearch = '/templateSearch'
export const TemplateSearchTable = '/TemplateSearchTable'
export const dataEntryViewAllFile = '/dataEntryViewAllFiles/:jobId/:boxId'
export const boxList = '/boxList'
export const activityList = '/activityList'
export const UploadCustomerData = '/UploadCustomerData'
export const AllJobsExceptionBoxes = '/AllJobsExceptionBoxes'
export const createActivity = '/CreateActivity'
export const addActivity = '/AddActivity'
export const viewActivity = '/ViewActivity'
export const viewTemplate = '/ViewTemplate'
export const ManageLockedFields = '/ManageLockedField'
export const activityAddImages = '/ActivityAddImages'
// export const activityAddImages = '/ActivityAddImagesScanbot'
export const ModifyTemplate = '/ModifyTemplate'
export const SmartCatalogDashboard = '/smartCatalogDashboard'
export const ImageExceptionDetails = '/ImageExceptionDetails'
export const viewBoxTransmittals = '/ViewBoxTransmittals'
export const addBoxTransmittals = '/AddBoxTransmittals'
export const uploadBoxTransmittals = '/AddBoxTransmittals/upload'
export const boxImageDetails = '/BoxImageDetails'
export const boxTransmittalExceptionDetails = '/BoxTransmittalExceptionDetails'
export const activityAddImagesBeta = '/ActivityAddImagesBeta'
export const bulkActivityImageUpload = '/BulkImageUpload'
export const batchTransmittals = '/BatchTransmittalDetails'
export const manageCustomerExclusions = '/ManageCustomerExclusions'
export const edgeAIBase = '/localAI'
export const localViewQcList = '/viewQualityCheckImages'
export const localactivityList = `${edgeAIBase}${activityList}`
export const localcreateActivity = `${edgeAIBase}${createActivity}`
export const localaddActivity = `${edgeAIBase}${addActivity}`
export const localviewActivity = `${edgeAIBase}${viewActivity}`
export const localviewTemplate = `${edgeAIBase}${viewTemplate}`
export const localManageLockedFields = `${edgeAIBase}${ManageLockedFields}`
export const localactivityAddImages = `${edgeAIBase}${activityAddImages}`
export const localModifyTemplate = `${edgeAIBase}${ModifyTemplate}`
export const localQualityCheck = `${edgeAIBase}${qualityCheck}`
export const localSmartCatalogDashboard = `${edgeAIBase}${SmartCatalogDashboard}`
export const localImageExceptionDetails = `${edgeAIBase}${ImageExceptionDetails}`
export const localviewBoxTransmittals = `${edgeAIBase}${viewBoxTransmittals}`
export const localaddBoxTransmittals = `${edgeAIBase}${addBoxTransmittals}`
export const localuploadBoxTransmittals = `${edgeAIBase}${uploadBoxTransmittals}`
export const localboxImageDetails = `${edgeAIBase}${boxImageDetails}`
export const localboxTransmittalExceptionDetails = `${edgeAIBase}${boxTransmittalExceptionDetails}`
export const localactivityAddImagesBeta = `${edgeAIBase}${activityAddImagesBeta}`
export const localBulkActivityImageUpload = `${edgeAIBase}${bulkActivityImageUpload}`
export const localbatchTransmittals = `${edgeAIBase}${batchTransmittals}`
export const viewQualityCheckImages = `${edgeAIBase}${localViewQcList}`
export const edgeCountrySettings = '/edgeCountrySettings'
export const edgeDeviceManagement = '/edgeDeviceManagement'
